import React from 'react';
import {
  SupportDoc,
} from 'views/EMR/PopulateSupport/supportDocsContent';

interface SupportDocsProps {
  docs: SupportDoc[];
}

export default function SupportDocs({ docs }: SupportDocsProps) {
  return (
    <div className="flex flex-col gap-6">
      <div className="bg-slate-50 border border-slate-200 rounded-lg p-4">
        <p className="text-xs uppercase tracking-wide text-slate-500 font-semibold mb-2">
          Articles
        </p>
        <ul className="text-sm text-slate-700 flex flex-wrap gap-3">
          {docs.map((doc) => (
            <li key={doc.id}>
              <a href={`#${doc.id}`} className="underline underline-offset-2 hover:text-slate-900">
                {doc.title}
              </a>
            </li>
          ))}
        </ul>
      </div>

      {docs.map((doc) => (
        <article key={doc.id} id={doc.id} className="flex flex-col gap-4">
          <h3 className="text-lg font-semibold text-slate-900">
            {doc.title}
          </h3>
          {doc.sections.map((section) => (
            <section key={section.heading} className="flex flex-col gap-2">
              <h4 className="text-sm font-semibold text-slate-800">
                {section.heading}
              </h4>
              {section.orderedItems && (
                <ol className="list-decimal list-inside text-sm text-slate-700 space-y-2">
                  {section.orderedItems.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ol>
              )}
              {section.bullets && (
                <ul className="list-disc list-inside text-sm text-slate-700 space-y-2">
                  {section.bullets.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </article>
      ))}
    </div>
  );
}
